import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  forwardRef
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { EINVOICE_STOCK_CLASSIFICATION } from '@core';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';

@Component({
  selector: 'app-einvoice-stock-classification-select',
  styleUrls: ['./einvoice-stock-classification-select.component.less'],
  templateUrl: './einvoice-stock-classification-select.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzInputModule,
    NzSelectModule,
    ViewItemComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceStockClassificationSelectComponent),
      multi: true
    }
  ]
})
export class EInvoiceStockClassificationSelectComponent
  implements ControlValueAccessor
{
  options = [...EINVOICE_STOCK_CLASSIFICATION];

  @Input() value: string = '';
  @Input() disabled = false;
  @Input() allowEdit = true;
  @Input() borderless = false;
  @Input() disableOption004 = false;
  @Output() readonly openChanged = new EventEmitter();
  @Output() readonly cleared = new EventEmitter();

  @Input() labelField: 'full' | 'code' | 'name' = 'full';

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    const item = this.options.find(x => x.value === this.value);
    return this.getLabel(item);
  }

  getLabel(item: any) {
    if (item) {
      if (this.labelField === 'code') return item.value;
      if (this.labelField === 'name') return item.name;
      return `${item.value} - ${item.name}`;
    }
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();

    if (!val) {
      this.cleared.emit(false);
    }
  }

  onOpenChanged(e: any) {
    this.openChanged.emit(e);
  }

  @ViewChild('selector') selector?: NzSelectComponent;
  enterEvent = false;
  mouseEvent = false;

  handleClick(event: MouseEvent): void {
    this.mouseEvent = true;
  }

    handleKeyDown(event: KeyboardEvent): void {
      const arrowKeys = ['ArrowLeft', 'ArrowRight','Escape'];
       
      // when current position in select component, want to move the left right column, close the option list
      if (arrowKeys.includes(event.key)|| (event.key === 'Enter' && event.ctrlKey) || event.ctrlKey) {
        if(this.selector?.nzOpen){
          this.selector.nzOpen = false;
        }
        /**
         * To detect the option list just opened using enter key or event
         * Default action was using ArrowDown to open the option list, Avoid it
         */
        if(this.enterEvent) this.enterEvent = false;
        if(this.mouseEvent) this.mouseEvent = false;
      }

      switch (event.key) {
        case 'ArrowDown':  
          // if search value is not empty, mean option list is open, so run default event action for select component
          if(this.selector?.['searchValue']) {
            event.stopPropagation();
          } else {
            // if not open by enter key or mouse, did not open the option list
            // default is using arrow down to open the option list, avoid it
            if(this.selector)
              if(!this.enterEvent && !this.mouseEvent){
                this.selector.nzOpen = false;
              }
              else{
                event.stopPropagation();
              }
          }
         break;

         // Make sure this component just listen the action from detail page
         case 'ArrowUp':
          if(this.selector)
            if(this.selector.nzOpen)
              event.stopPropagation();
         break;

         case 'Enter':
          /**
           * every time press enter key will reverse the boolean value, default it is false
           * to make sure the timing when customer select component selected value
           * that time event = false to make sure process sequence
           */
          if(!this.enterEvent) this.enterEvent = true;
          else this.enterEvent = false;

          /**
           * To double comfirm the option list was closed
           * If Remove below, will happen one situation, after customer select component selected value,
           * and move to next column, the option list will open again
           */
          if (!this.selector?.nzOpen) {
            if(this.selector)
              this.selector.nzOpen = false;
          }
          break;
          
          default:
            break;
      }

    }
}
